/**
 * Ryan O'Dowd
 * 2025-01-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';
import globals from '@utils/globals';

const getStyles = ({safeAreaInsets, windowWidth, windowHeight, windowWidthRaw}) => {
  const marginHorizontal = (Math.max(windowWidth - globals.maxInnerWidth, 0) / 2) + 16;
  const marginVertical = 16;
  const marginHorizontalMacOs = (Math.max(windowWidthRaw - windowWidth, 0) / 2) + 16; // @TODO: this shouldn't be needed, but i think there's a bug that's reporting the screen dimensions intead of the window dimensions, but only on macos; okay to use in marginHorizontal below because if it's not web, this value is the same as marginHorizontal
  const fullWidth = Math.min(windowWidth, globals.maxInnerWidth) - (marginHorizontal * 2);
  const fullHeight = windowHeight - safeAreaInsets.top - safeAreaInsets.bottom - (marginVertical * 2);

  return {
    container: {
      ...(Platform.OS === 'web'
        ? {
          display: 'flex',
          alignSelf: 'center',
          justifySelf: 'center',
        }
        : {}
      ),
      marginHorizontal: Platform.OS === 'web' ? 0 : marginHorizontalMacOs, // @NOTE: this is captured in maxWidth below
      maxWidth: fullWidth,
      maxHeight: fullHeight,
    },
    fullWidth: {
      display: 'flex',
      width: fullWidth,
      ...(Platform.OS === 'web'
        ? {
          marginHorizontal: 0,
        }
        : {}
      ),
    },
    fullHeight: {
      display: 'flex',
      height: fullHeight,
      ...(Platform.OS === 'web'
        ? {
          marginVertical: 0,
        }
        : {}
      ),
    },
  };
};

export default getStyles;
